import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { translate, formatData, enumColor } from '../../../../../utils/util';
import { ENUMS } from '../../../../../utils/constants';
import { connect } from 'react-redux';

const LinePickingListItemOrder = (props) => {
    const getStatusAlertRoute = (value) => enumColor(ENUMS.eTypeAlert, value);

    const getOrderItemCode = (orderItems) => {
        let orderItemCode = orderItems && orderItems.length > 0 ? orderItems[0].orderItemCode : "";
        if (orderItems && orderItems.length > 1) {
            const filterOrderItem = orderItems.find(o => o.status !== ENUMS.eOrderItemStatus.Canceled.value
                && o.status !== ENUMS.eOrderItemStatus.Repicking.value
                && o.status !== ENUMS.eOrderItemStatus.Finished.value)

            orderItemCode = filterOrderItem ? filterOrderItem.orderItemCode : orderItems[0].orderItemCode
        }
        return `${orderItemCode}`
    };

    const renderItems = () => {
        return (
            <div className='row'>
                <div className='col s6'>
                    <span className="title sixth-text-color">
                        {props.data?.items[0]?.partnumber}
                    </span>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="title sixth-text-color">
                            {props.data?.items[0]?.description}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="title sixth-text-color">
                            {props.data.orderCode}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="title sixth-text-color">
                            {getOrderItemCode(props.data?.items)}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {props.data?.items[0]?.location}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {translate('line-picking:linepicking.mdr')}: {props.data.items[0]?.mdrType}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {translate('line-picking:linepicking.amount')}: {props.data?.items[0]?.quantity}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {translate('physical-confirmation:date')} {translate('line-picking:linepicking.order')}: {formatData(props.data.date)}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            {translate('physical-confirmation:cim')}: {props.data.items[0]?.cim}
                        </span>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            Rota: {props.data?.route?.code || ''}
                        </span>
                    </div>
                    {
                        props.data.status === ENUMS.eOrderStatus.WaitingFinish.value &&
                        <div className="col s12" style={{ padding: '0px' }}>
                            <span className="title sixth-text-color">
                                Aguardando Delivery
                            </span>
                        </div>
                    }
                </div>
                <div className='col s6'>
                    {
                        props.data.items[0]?.mapping &&
                        <>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    Rota PDU: {props.data.items[0]?.mapping.route || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    Linha: {props.data.items[0]?.mapping.line || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    Lado: {props.data.items[0]?.mapping.side || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    Rua: {props.data.items[0]?.mapping.street || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    Estação: {props.data.items[0]?.mapping.station || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                                    Gravit: {props.data.items[0]?.mapping.gravitational || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                                    Vaga: {props.data.items[0]?.mapping.space || ''}
                                </span>
                            </div>
                            <div className="col s12" style={{ padding: '0px' }}>
                                <span className="truncate second-text-color" style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                                    Qtd Linha: {props.data.items[0]?.mapping.quantityLine || ''}
                                </span>
                            </div>
                        </>
                    }
                    <div className="col s12" style={{ padding: '0px' }}>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
                            {translate('delivery:fields.pdu')}: {props.data.items[0]?.nextLocation}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Link
            className="row"
            style={{
                display: 'block',
                marginBottom: '0px',
                position: 'relative',
                overflow: 'hidden',
            }}
            to={props.route}
            onClick={(event) => {
                if (props.onSelectChange) {
                    props.onSelectChange(event);
                }
            }}
        >
            {renderItems()}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 10,
                    width: '13px',
                    backgroundColor: getStatusAlertRoute(props.data.typeAlert),
                    zIndex: 1,
                }}
            />
        </Link>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(LinePickingListItemOrder)));
